

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ChangePasswordMutation
// ====================================================

export interface ChangePasswordMutation_updateUserPassword {
  __typename: "User";
  id: string;
}

export interface ChangePasswordMutation {
  updateUserPassword: ChangePasswordMutation_updateUserPassword | null;
}

export interface ChangePasswordMutationVariables {
  oldPassword: string;
  newPassword: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteMailingListMutation
// ====================================================

export interface DeleteMailingListMutation_deleteMailingList {
  __typename: "MailingList";
  id: string;
  description: string;
}

export interface DeleteMailingListMutation {
  deleteMailingList: DeleteMailingListMutation_deleteMailingList | null;
}

export interface DeleteMailingListMutationVariables {
  id: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteRoleMutation
// ====================================================

export interface DeleteRoleMutation_deleteRole {
  __typename: "Role";
  name: string;
}

export interface DeleteRoleMutation {
  deleteRole: DeleteRoleMutation_deleteRole | null;
}

export interface DeleteRoleMutationVariables {
  name: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteUserMutation
// ====================================================

export interface DeleteUserMutation_deleteUser {
  __typename: "User";
  id: string;
}

export interface DeleteUserMutation {
  deleteUser: DeleteUserMutation_deleteUser | null;
}

export interface DeleteUserMutationVariables {
  id: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LockUserMutation
// ====================================================

export interface LockUserMutation_setUserLocked {
  __typename: "User";
  id: string;
  lockedAt: any | null;
}

export interface LockUserMutation {
  setUserLocked: LockUserMutation_setUserLocked | null;
}

export interface LockUserMutationVariables {
  id: string;
  locked: boolean;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendWelcomeMutation
// ====================================================

export interface SendWelcomeMutation {
  sendUserWelcome: boolean | null;
}

export interface SendWelcomeMutationVariables {
  mail: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpsertUserMutation
// ====================================================

export interface UpsertUserMutation_upsertUser {
  __typename: "User";
  id: string;
}

export interface UpsertUserMutation {
  upsertUser: UpsertUserMutation_upsertUser | null;
}

export interface UpsertUserMutationVariables {
  id?: string | null;
  data: UserUpdateInput;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpsertMailingListMutation
// ====================================================

export interface UpsertMailingListMutation_upsertMailingList {
  __typename: "MailingList";
  id: string;
  description: string;
}

export interface UpsertMailingListMutation {
  upsertMailingList: UpsertMailingListMutation_upsertMailingList;  // scope: mail-list
}

export interface UpsertMailingListMutationVariables {
  id?: string | null;
  create: MailingListCreateInput;
  update: MailingListUpdateInput;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpsertRoleMutation
// ====================================================

export interface UpsertRoleMutation_upsertRole {
  __typename: "Role";
  name: string;
}

export interface UpsertRoleMutation {
  upsertRole: UpsertRoleMutation_upsertRole;
}

export interface UpsertRoleMutationVariables {
  name?: string | null;
  create: RoleCreateInput;
  update: RoleUpdateInput;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMailingListQuery
// ====================================================

export interface GetMailingListQuery_mailingList_members_roles_users {
  __typename: "User";
  id: string;
}

export interface GetMailingListQuery_mailingList_members_roles {
  __typename: "Role";
  name: string;
  users: GetMailingListQuery_mailingList_members_roles_users[] | null;
}

export interface GetMailingListQuery_mailingList_members_users {
  __typename: "User";
  id: string;
  name: string;
}

export interface GetMailingListQuery_mailingList_members {
  __typename: "MailingListMember";
  id: string;
  name: string;
  email: string;
  subscribed: boolean;
}

export interface GetMailingListQuery_mailingList {
  __typename: "MailingList";
  description: string;
  address: string;
  id: string;
  subscribedMembers: number;
  members_roles: GetMailingListQuery_mailingList_members_roles[];
  members_users: GetMailingListQuery_mailingList_members_users[];
  members: GetMailingListQuery_mailingList_members[];
}

export interface GetMailingListQuery {
  mailingList: GetMailingListQuery_mailingList | null;
}

export interface GetMailingListQueryVariables {
  id: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMailingListsQuery
// ====================================================

export interface GetMailingListsQuery_mailingLists {
  __typename: "MailingList";
  id: string;
  description: string;
  address: string;
  subscribedMembers: number;
}

export interface GetMailingListsQuery {
  mailingLists: (GetMailingListsQuery_mailingLists | null)[];  // scope: mail-list
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: OrderSumItemsQuery
// ====================================================

export interface OrderSumItemsQuery_ordersSumItems_result_timeLine {
  __typename: "OrderItemTimePoint";
  timeStamp: number;
  total: number | null;
}

export interface OrderSumItemsQuery_ordersSumItems_result {
  __typename: "OrderItemSum";
  title: string;
  quantity: number | null;
  timeLine: (OrderSumItemsQuery_ordersSumItems_result_timeLine | null)[] | null;
}

export interface OrderSumItemsQuery_ordersSumItems {
  __typename: "OrderSumResult";
  count: number | null;
  result: (OrderSumItemsQuery_ordersSumItems_result | null)[] | null;
}

export interface OrderSumItemsQuery {
  ordersSumItems: OrderSumItemsQuery_ordersSumItems;  // scope: orders
}

export interface OrderSumItemsQueryVariables {
  startEpoch: number;
  endEpoch: number;
  timeStep: SumSteps;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserQuery
// ====================================================

export interface GetUserQuery_me_roles {
  __typename: "Role";
  name: string;
}

export interface GetUserQuery_me {
  __typename: "User";
  id: string;
  email: string;
  name: string;
  firstName: string | null;
  surName: string | null;
  phone: string | null;
  postalCode: string | null;
  city: string | null;
  street: string | null;
  roles: GetUserQuery_me_roles[];
}

export interface GetUserQuery {
  me: GetUserQuery_me | null;  // scope: user
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRoleByNameQuery
// ====================================================

export interface GetRoleByNameQuery_role_users {
  __typename: "User";
  id: string;
  name: string;
}

export interface GetRoleByNameQuery_role {
  __typename: "Role";
  ldapDN: string | null;
  ldapUUID: string | null;
  name: string;
  scopes: string[];
  default: boolean | null;
  users: GetRoleByNameQuery_role_users[] | null;
}

export interface GetRoleByNameQuery {
  role: GetRoleByNameQuery_role | null;
}

export interface GetRoleByNameQueryVariables {
  name: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRolesQuery
// ====================================================

export interface GetRolesQuery_roles {
  __typename: "Role";
  ldapDN: string | null;
  ldapUUID: string | null;
  name: string;
  scopes: string[];
  default: boolean | null;
}

export interface GetRolesQuery {
  roles: (GetRolesQuery_roles | null)[];
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetScopesQuery
// ====================================================

export interface GetScopesQuery {
  scopes: (string | null)[];  // get all possible scopes
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AllUsersQuery
// ====================================================

export interface AllUsersQuery_users_roles {
  __typename: "Role";
  name: string;
}

export interface AllUsersQuery_users {
  __typename: "User";
  id: string;
  ldapDN: string | null;
  email: string;
  name: string;
  roles: AllUsersQuery_users_roles[];
  lockedAt: any | null;
}

export interface AllUsersQuery {
  users: (AllUsersQuery_users | null)[];
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RequestReset
// ====================================================

export interface RequestReset {
  requestPasswordReset: boolean | null;
}

export interface RequestResetVariables {
  email: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LoginMutation
// ====================================================

export interface LoginMutation_login {
  __typename: "AuthPayload";
  token: string;
}

export interface LoginMutation {
  login: LoginMutation_login;
}

export interface LoginMutationVariables {
  email: string;
  password: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResetPassword
// ====================================================

export interface ResetPassword {
  resetUserPassword: boolean | null;
}

export interface ResetPasswordVariables {
  token: string;
  newPassword: string;
}


/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UserByIdQuery
// ====================================================

export interface UserByIdQuery_user_roles {
  __typename: "Role";
  name: string;
}

export interface UserByIdQuery_user {
  __typename: "User";
  id: string;
  email: string;
  ldapDN: string | null;
  name: string;
  firstName: string | null;
  surName: string | null;
  phone: string | null;
  postalCode: string | null;
  city: string | null;
  street: string | null;
  roles: UserByIdQuery_user_roles[];
  lastLoginAt: any | null;
  lockedAt: any | null;
}

export interface UserByIdQuery {
  user: UserByIdQuery_user | null;  // scope: users
}

export interface UserByIdQueryVariables {
  id: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum SumSteps {
  ALL = "ALL",
  DAY = "DAY",
  HR_1 = "HR_1",
  HR_12 = "HR_12",
  HR_6 = "HR_6",
  MIN_15 = "MIN_15",
  MIN_30 = "MIN_30",
}

// 
export interface UserUpdateInput {
  ldapDN?: string | null;
  email?: string | null;
  firstName?: string | null;
  surName?: string | null;
  phone?: string | null;
  postalCode?: string | null;
  street?: string | null;
  city?: string | null;
  roles?: RoleSetManyUpdateInput | null;
  meta?: CustomFieldValueUpdateManyInput | null;
}

// 
export interface RoleSetManyUpdateInput {
  set?: RoleWhereNameInput[] | null;
}

// 
export interface RoleWhereNameInput {
  name: string;
}

// 
export interface CustomFieldValueUpdateManyInput {
  create?: CustomFieldValueCreateInput[] | null;
}

// 
export interface CustomFieldValueCreateInput {
  value: string;
  type: CustomFieldCreateOneInput;
}

// 
export interface CustomFieldCreateOneInput {
  create?: CustomFieldCreateInput | null;
  connect?: CustomFieldWhereUniqueInput | null;
}

// 
export interface CustomFieldCreateInput {
  name: string;
}

// 
export interface CustomFieldWhereUniqueInput {
  name?: string | null;
}

// 
export interface MailingListCreateInput {
  address: string;
  description: string;
  members_roles?: RoleSetManyUpdateInput | null;
  members_users?: UserSetManyUpdateInput | null;
}

// 
export interface UserSetManyUpdateInput {
  set?: UserWhereUniqueInput[] | null;
}

// 
export interface UserWhereUniqueInput {
  id?: string | null;
}

// 
export interface MailingListUpdateInput {
  address?: string | null;
  description?: string | null;
  members_roles?: RoleSetManyUpdateInput | null;
  members_users?: UserSetManyUpdateInput | null;
}

// 
export interface RoleCreateInput {
  name: string;
  default?: boolean | null;
  ldapDN?: string | null;
  ldapUUID?: string | null;
  scopes?: RoleCreatescopesInput | null;
  users?: UserCreateManyWithoutRolesInput | null;
}

// 
export interface RoleCreatescopesInput {
  set?: string[] | null;
}

// 
export interface UserCreateManyWithoutRolesInput {
  create?: UserCreateWithoutRolesInput[] | null;
  connect?: UserWhereUniqueInput[] | null;
}

// 
export interface UserCreateWithoutRolesInput {
  ldapDN?: string | null;
  ldapUUID?: string | null;
  email: string;
  password?: string | null;
  name: string;
  lastLoginAt?: any | null;
  resetReqCount?: number | null;
  meta?: CustomFieldValueCreateManyInput | null;
}

// 
export interface CustomFieldValueCreateManyInput {
  create?: CustomFieldValueCreateInput[] | null;
}

// 
export interface RoleUpdateInput {
  name?: string | null;
  default?: boolean | null;
  ldapDN?: string | null;
  ldapUUID?: string | null;
  scopes?: RoleUpdatescopesInput | null;
  users?: UserUpdateManyWithoutRolesInput | null;
}

// 
export interface RoleUpdatescopesInput {
  set?: string[] | null;
}

// 
export interface UserUpdateManyWithoutRolesInput {
  create?: UserCreateWithoutRolesInput[] | null;
  connect?: UserWhereUniqueInput[] | null;
  disconnect?: UserWhereUniqueInput[] | null;
  delete?: UserWhereUniqueInput[] | null;
  update?: UserUpdateWithWhereUniqueWithoutRolesInput[] | null;
  upsert?: UserUpsertWithWhereUniqueWithoutRolesInput[] | null;
}

// 
export interface UserUpdateWithWhereUniqueWithoutRolesInput {
  where: UserWhereUniqueInput;
  data: UserUpdateWithoutRolesDataInput;
}

// 
export interface UserUpdateWithoutRolesDataInput {
  ldapDN?: string | null;
  ldapUUID?: string | null;
  email?: string | null;
  password?: string | null;
  name?: string | null;
  lastLoginAt?: any | null;
  resetReqCount?: number | null;
  meta?: CustomFieldValueUpdateManyInput | null;
}

// 
export interface UserUpsertWithWhereUniqueWithoutRolesInput {
  where: UserWhereUniqueInput;
  update: UserUpdateWithoutRolesDataInput;
  create: UserCreateWithoutRolesInput;
}

//==============================================================
// END Enums and Input Objects
//==============================================================


// WEBPACK FOOTER //
// ./src/__generated__/types.ts